import { fireDTMEvent, updateDTMEvent } from '../utils/dtm';
import { getDTMData, getMarketCode } from '../selectors';

const dtmTagging = store => next => action => {
  const returnValue = next(action);

  if (action.meta && action.meta.dtmTag) {
    try {
      if (action.meta.updateDTMEventOnly === true) {
        const dtmData = { ...getDTMData(store.getState()), ...{ marketCode: getMarketCode(store.getState()) } };
        updateDTMEvent(dtmData);
      } else {
        fireDTMEvent(getDTMData(store.getState()));
      }
    } catch (e) {
      // CONTINUE ON DTM FAILURE
    }
  }

  return returnValue;
};
export default dtmTagging;
